import ApiClient from '@/api-client';

export default {
    namespaced: true,
    state: {
        waterSystemId: null,
        waterSystem: {},
    },

    mutations: {
        setWaterSystem(state, waterSystem) {
            state.waterSystem = waterSystem;
        },
        updateWaterSystemId(state, waterSystemId) {
            state.waterSystemId = waterSystemId;
        },
    },
    actions: {
        async getWaterSystem({ commit }, waterSystemId) {
            const response = await ApiClient.get(`/api/water-systems/${waterSystemId}`);
            commit('setWaterSystem', response.data);
        },
        async setWaterSystem({ state, dispatch, commit }, waterSystemId) {
            commit('updateWaterSystemId', waterSystemId);
            if (state.waterSystem.id !== waterSystemId) {
                dispatch('getWaterSystem', waterSystemId);
            }
        },
    },
};
